import { dbAdapter } from './databaseAdapter';
import { customerService } from './customerService';
import { staffService } from './staffService';
import { inventoryService } from './inventoryService';
import { transactionService } from './transactionService';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const reportService = {

  
  // GET REPORT DATA — DENGAN FILTER STATUS
  getReportData: async (startDate, endDate, statusFilter = 'all') => {
    const transactions = await transactionService.getAll() || [];
    const workOrders = await dbAdapter.get('work_orders') || [];
    const customers = await customerService.getAll() || [];
    const staff = await staffService.getAll() || [];
    const inventory = await inventoryService.getAll() || [];

    //FILTER WORK ORDERS BY STATUS (kalau tidak 'all')
    let filteredWOs = workOrders;
    if (statusFilter !== 'all') {
      filteredWOs = workOrders.filter(wo => wo.status === statusFilter);
    }

    //HITUNG CANCELLED & TOTAL WO (AKTIF)
    const cancelled = workOrders.filter(wo => wo.status === 'cancelled').length;
    const totalWO = workOrders.filter(wo => wo.status !== 'cancelled').length;

    // Filter transaksi by date
    const filtered = transactions.filter(t => {
      if (!startDate && !endDate) return true;
      const tDate = new Date(t.date);
      const start = startDate ? new Date(startDate) : new Date(0);
      const end = endDate ? new Date(endDate) : new Date();
      end.setHours(23, 59, 59);
      return tDate >= start && tDate <= end;
    });

    console.log('📊 [REPORT] Total Transaksi:', filtered.length);
    console.log('📊 [REPORT] Filter Status:', statusFilter);
    console.log('📊 [REPORT] Cancelled:', cancelled);
    console.log('📊 [REPORT] Total WO Aktif:', totalWO);

    // 1️⃣ REVENUE - dari transaksi yang status PAID
    const paid = filtered.filter(t => t.payment_status === 'paid' || t.paymentStatus === 'paid');
    const pending = filtered.filter(t => t.payment_status === 'pending' || t.paymentStatus === 'pending');
    const totalRevenue = paid.reduce((sum, t) => sum + (t.total || 0), 0);
    const totalPending = pending.reduce((sum, t) => sum + (t.total || 0), 0);
    const totalTransactions = filtered.length;

    console.log('💰 [REVENUE] Total Revenue:', totalRevenue);

    // 2️⃣ BIAYA - HANYA DARI WO YANG TRANSAKSINYA PAID!
    const paidWoIds = paid
      .map(t => t.work_order_id || t.workOrderId)
      .filter(id => id && id !== '' && id !== undefined);

    let totalLaborCost = 0;
    let totalMaterialCost = 0;
    let totalCost = 0;

    if (paidWoIds.length > 0) {
      const relatedWOs = workOrders.filter(wo => paidWoIds.includes(wo.id));
      
      console.log('📦 [COST] Related WOs:', relatedWOs.map(wo => ({ 
        id: wo.id, 
        totalCost: wo.totalCost,
        laborCost: wo.laborCost,
        materialCount: wo.materials?.length || 0
      })));
      
      relatedWOs.forEach(wo => {
        let total = Number(wo.total_cost || wo.totalCost || 0);
        const labor = Number(wo.labor_cost || wo.laborCost || 0);
        
        if (total === 0 && wo.materials && wo.materials.length > 0) {
          const materialTotal = wo.materials.reduce((sum, m) => {
            const qty = parseInt(m.qty) || 0;
            const price = parseInt(m.price) || 0;
            return sum + (qty * price);
          }, 0);
          total = labor + materialTotal;
          console.log(`⚠️ WO ${wo.id} totalCost 0, dihitung manual: ${total}`);
        }
        
        const material = total - labor;
        totalLaborCost += labor;
        totalMaterialCost += material;
        totalCost += total;
      });
    }

    // 3️⃣ PROFIT & MARGIN
    const totalProfit = totalRevenue - totalCost;
    const margin = totalRevenue > 0 ? Math.round((totalProfit / totalRevenue) * 100) : 0;

    console.log('📈 [PROFIT] Revenue:', totalRevenue);
    console.log('📈 [PROFIT] Cost:', totalCost);
    console.log('📈 [PROFIT] Profit:', totalProfit);
    console.log('📈 [PROFIT] Margin:', margin + '%');

    return {
      transactions: filtered,
      paid,
      pending,
      totalRevenue,
      totalPending,
      totalTransactions,
      totalProfit,
      margin,
      totalCost,
      totalLaborCost,
      totalMaterialCost,
      customers,
      staff,
      inventory,
      workOrders: filteredWOs,
      totalWO,
      cancelled,
      dateRange: { startDate, endDate }
    };
  },

  // ===============
  // MONTHLY SUMMARY
  // ===============
  getMonthlySummary: async (year) => {
    const yearNum = year || new Date().getFullYear();
    const transactions = await transactionService.getAll() || [];
    const paid = transactions.filter(t => t.payment_status === 'paid' || t.paymentStatus === 'paid');
    
    const months = [];
    for (let i = 0; i < 12; i++) {
      const monthTransactions = paid.filter(t => {
        if (!t.date) return false;
        const tDate = new Date(t.date);
        return tDate.getMonth() === i && tDate.getFullYear() === yearNum;
      });
      
      const revenue = monthTransactions.reduce((sum, t) => sum + (t.total || 0), 0);
      const count = monthTransactions.length;
      
      months.push({
        month: new Date(yearNum, i, 1).toLocaleString('id-ID', { month: 'long' }),
        revenue,
        count
      });
    }
    return months;
  },

 
  //STAFF PERFORMANCE — DENGAN TEAM (UPDATED)
  getStaffPerformance: async () => {
    const staff = await staffService.getAll() || [];
    const workOrders = await dbAdapter.get('work_orders') || [];
    const transactions = await transactionService.getAll() || [];

    //Ambil semua staff (termasuk yang commission 0)
    return staff.map(member => {
      //1. Cari WO yang melibatkan staff ini di TEAM
      const teamWOs = workOrders.filter(wo => {
        const team = wo.team || [];
        return team.some(m => m.id === member.id);
      });

      //2. Cari WO yang staff ini sebagai penanggung jawab (staff_id)
      const assignedWOs = workOrders.filter(wo => 
        wo.staff_id === member.id || wo.staffId === member.id
      );

      //3. Gabungkan (unique)
      const allRelatedWOs = [...teamWOs, ...assignedWOs];
      const uniqueWOs = allRelatedWOs.filter((wo, index, self) => 
        self.findIndex(w => w.id === wo.id) === index
      );

      //4. Hitung komisi dari transaksi yang sudah PAID
      let totalCommission = 0;

      uniqueWOs.forEach(wo => {
        // Cari transaksi untuk WO ini
        const transaction = transactions.find(t => 
          (t.work_order_id === wo.id || t.workOrderId === wo.id) &&
          (t.payment_status === 'paid' || t.paymentStatus === 'paid')
        );

        if (transaction) {
          //Cari member di team WO
          const teamMember = (wo.team || []).find(m => m.id === member.id);
          
          //Ambil commission rate dari staff (atau dari team member)
          let commissionRate = 0;
          if (teamMember) {
            //Prioritas: rate dari staff, fallback ke member.rate
            commissionRate = member.commission || teamMember.rate || 0;
          } else {
            //Kalau staff tidak di team, pakai commission dari staff
            commissionRate = member.commission || 0;
          }

          //Hitung komisi = total transaksi × (commissionRate / 100)
          const commission = transaction.total * (commissionRate / 100);
          totalCommission += commission;
        }
      });

      //5. Hitung orders yang completed/delivered
      const completedOrders = uniqueWOs.filter(wo => 
        wo.status === 'completed' || wo.status === 'delivered'
      );
      const pendingOrders = uniqueWOs.filter(wo => wo.status === 'pending');
      const inProgressOrders = uniqueWOs.filter(wo => wo.status === 'in-progress');

      return {
        name: member.name || 'Unknown',
        level: member.level || '-',
        totalOrders: uniqueWOs.length,
        completed: completedOrders.length,
        pending: pendingOrders.length,
        inProgress: inProgressOrders.length,
        completionRate: uniqueWOs.length > 0 
          ? Math.round((completedOrders.length / uniqueWOs.length) * 100) 
          : 0,
        commission: member.commission || 0,
        totalCommission: Math.round(totalCommission)
      };
    });
  },


  // CUSTOMER REPORT
  getCustomerReport: async () => {
    const customers = await customerService.getAll() || [];
    const workOrders = await dbAdapter.get('work_orders') || [];
    const transactions = await transactionService.getAll() || [];
    
    return customers.map(customer => {
      const orders = workOrders.filter(wo => 
        wo.customer_id === customer.id || wo.customerId === customer.id
      );
      const customerTransactions = transactions.filter(t => 
        t.customer_id === customer.id || t.customerId === customer.id
      );
      const paid = customerTransactions.filter(t => t.payment_status === 'paid' || t.paymentStatus === 'paid');
      
      return {
        name: customer.name || 'Unknown',
        phone: customer.phone || '-',
        email: customer.email || '-',
        type: customer.type || '-',
        totalOrders: orders.length,
        totalTransactions: customerTransactions.length,
        totalSpent: paid.reduce((sum, t) => sum + (t.total || 0), 0),
        lastOrder: orders.length > 0 ? orders.sort((a, b) => 
          new Date(b.created_at || b.createdAt) - new Date(a.created_at || a.createdAt)
        )[0]?.created_at || orders[0]?.createdAt : null
      };
    });
  },


  // INVENTORY REPORT
  getInventoryReport: async () => {
    const inventory = await inventoryService.getAll() || [];
    const categories = await inventoryService.getCategories() || [];
    const suppliers = await inventoryService.getSuppliers() || [];
    
    return inventory.map(item => {
      const category = categories.find(c => 
        c.id === item.category_id || c.id === item.categoryId
      );
      const supplier = suppliers.find(s => 
        s.id === item.supplier_id || s.id === item.supplierId
      );
      const totalValue = (item.stock || 0) * (item.buy_price || item.buyPrice || 0);
      const potentialRevenue = (item.stock || 0) * (item.sell_price || item.sellPrice || 0);
      
      return {
        name: item.name || 'Unknown',
        sku: item.sku || '-',
        category: category ? category.name : '-',
        supplier: supplier ? supplier.name : '-',
        stock: item.stock || 0,
        minStock: item.min_stock || item.minStock || 0,
        unit: item.unit || 'Pcs',
        buyPrice: item.buy_price || item.buyPrice || 0,
        sellPrice: item.sell_price || item.sellPrice || 0,
        totalValue,
        potentialRevenue,
        location: item.location || '-',
        status: (item.stock || 0) <= 0 ? 'Out of Stock' : 
                (item.stock || 0) <= (item.min_stock || item.minStock || 0) * 0.5 ? 'Critical' :
                (item.stock || 0) <= (item.min_stock || item.minStock || 0) ? 'Low Stock' : 'In Stock'
      };
    });
  },

 
  // EXPORT TO EXCEL
  exportToExcel: (data, filename, sheetName = 'Sheet1') => {
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, `${filename}.xlsx`);
  },


  // EXPORT TO CSV
  exportToCSV: (data, filename) => {
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${filename}.csv`);
  },


  // FORMAT CURRENCY
  formatCurrency: (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount || 0);
  }
};